import { getColumns } from "./scientificNames.columns";
import { fetchScientificNames } from "./scientificNameService";

/* ========== helpers ========== */
const norm = (s) =>
  (s ?? "")
    .toString()
    .normalize("NFKC")
    .toLowerCase()
    .replace(/\s+/g, " ")
    .trim();

const pickFirst = (obj, keys = []) => {
  for (const k of keys) {
    const v = obj?.[k];
    if (v !== undefined && v !== null && String(v).trim() !== "") return v;
  }
  return "";
};

// Author 表示: 2名なら「A & B」、3名以上は「A, B & C」
const formatAuthors = (rows) => {
  if (!Array.isArray(rows) || rows.length === 0) return "—";
  const names = [...rows]
    .sort((a, b) => (a?.author_order ?? 0) - (b?.author_order ?? 0))
    .map((r) => r?.researchers)
    .filter(Boolean)
    .map((a) => a?.last_name || a?.lastName)
    .filter(Boolean);

  if (names.length === 0) return "—";
  if (names.length === 1) return names[0];
  if (names.length === 2) return `${names[0]} & ${names[1]}`;
  return `${names.slice(0, -1).join(", ")} & ${names[names.length - 1]}`;
};

const fmtDate = (iso) => {
  if (!iso) return "";
  try {
    const d = new Date(iso);
    return d.toLocaleString("ja-JP", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
    });
  } catch {
    return "";
  }
};

/* ========== plugin ========== */
const plugin = {
  table: "scientific_names",
  defaultSort: { field: "name_spell_valid", sort: "asc" },

  // *FK に頼らず* 必要なものは自前で合成できるよう、最低限の列を取得
  select: `
    id,
    name_spell_valid,
    name_spell_original,
    authority_year,
    current_rank,
    current_parent,
    original_rank,
    original_parent,
    valid_name_id,
    type_taxa_id,
    extant_fossil,
    type_category,
    type_locality,
    type_sex,
    type_repository,
    type_repository_id,
    type_host,
    source_of_original_description,
    page,
    remark,
    last_update,
    scientific_name_and_author (
      author_order,
      researchers:researcher_id (
        id,
        last_name,
        first_name
      )
    )
  `,

  normalize(row) {
    const _nameValidDisp =
      row?._nameValidDisp ||
      pickFirst(row, ["name_spell_valid", "valid_name", "name_valid", "name", "id"]) ||
      "";
    const _nameOrigDisp =
      row?._nameOrigDisp ||
      pickFirst(row, ["name_spell_original", "name_original", "original_name", "name_spell_valid", "id"]) ||
      "";
    return {
      ...row,
      _nameValidDisp,
      _nameOrigDisp,
      _authors: formatAuthors(row?.scientific_name_and_author),
      _lastUpdateDisp: fmtDate(row?.last_update),
    };
  },

  /**
   * サーバーサイドページング版 fetch
   */
  async fetch(args) {
    // Pass the normalize function from this plugin's context to the service.
    return fetchScientificNames({ ...args, normalize: this.normalize });
  },

  searchLocal(rows, q) {
    if (!q) return rows;
    const needle = norm(q);
    const fields = [
      "_nameValidDisp",
      "_nameOrigDisp",
      "_authors",
      "authority_year",
      "current_rank",
      "original_rank",
      "_currentParentName",
      "_originalParentName",
      "type_category",
      "type_locality",
      "type_sex",
      "type_repository",
    ];
    return rows.filter((r) =>
      fields.some((f) => (r?.[f] || "").toString().toLowerCase().includes(needle))
    );
  },

  columns: getColumns,
};

export default plugin;
